import { Config } from "../config/config";
import { DOMAIN_CONTANTS } from "../constants/domains/domain-contants";
import { cultureData } from "../datas/culture-data";
import { getDomain } from "./domain.helper";

export class LocalStorageHelper {
    public static getSpeechRecognitionLanguage(): string {
        const language = localStorage.getItem(Config.VITE_APP_LANGUAGE_KEY) as string;
        const culture = cultureData.find(x => x.key == language)?.value ?? "tr";
        return culture;
    }
    public static setAndGetDefaultCultureAndLanguageByDomainBeforeLogin(): string {
        const path = window.location.pathname;
        if (path == '/login' && getDomain() == DOMAIN_CONTANTS.syncflow) {
            localStorage.setItem(Config.VITE_APP_LANGUAGE_KEY, "en-US");
            localStorage.setItem(Config.VITE_APP_CULTURE_KEY, "en-US");
        }
        return this.getLanguage();
    }
    public static getLanguage(): string {
        return localStorage.getItem(Config.VITE_APP_LANGUAGE_KEY) ? localStorage.getItem(Config.VITE_APP_LANGUAGE_KEY)?.replace('_', '-') as string : "tr-TR";
    }
    public static getCulture(): string {
        return localStorage.getItem(Config.VITE_APP_CULTURE_KEY) ? localStorage.getItem(Config.VITE_APP_CULTURE_KEY)?.replace('_', '-') as string : "tr-TR";
    }
    public static getAccessToken(): string {
        return localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY) ? localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY) as string : "";
    }
}